<template>
  <div class="wash-list-component">
    <div class="row">
      <div class="col-sm-12">
        <vue-form ref="form"
          :options="{ permalink: 'generateWashList' }"
          @load="refresh()">
          <div class="card-header" slot="title">
            <span class="fa fa-fw fa-paper-plane fa-lg"></span> Email Wash List
          </div>
          <template slot="actions">
            <div class="col-sm-8 offset-sm-4">
              <button type="button" class="btn btn-default" @click="refresh()">
                <span class="fa fa-fw fa-sync"></span> Refresh
              </button>
              <button type="button" class="btn btn-primary" @click="send()">
                <span class="fa fa-paper-plane fa-fw"></span> Send
              </button>
            </div>
          </template>
        </vue-form>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <responsive-table
          :table="washList"
          @orderColumn="order($event)"
          default-sort-column="address"
          default-sort="ASC"
          @toggle="handleToggle($event)">
        </responsive-table>
      </div>
    </div>
    <div class="row" v-if="listModified">
      <div class="notification account-message-box">
        <div class="notification-header">
          <i class="notification-header-icon fa" :class="{
            'fa-sync': !listSaved,
            'fa-check': listSaved
          }"></i>
          <span class="notification-header-title mdl-color-text--primary">
            {{ listSaved ? 'List Saved!' : 'Unsaved Changes!' }}
          </span>
        </div>
        <div class="notification-content">
          <p class="notification-content-text">
            Wash List {{ listSaved ? 'Saved' : 'Modified' }}
            </p>
          <template v-if="listSaved">
            <p class="notification-content-text"><strong>Your changes were saved</strong></p>
          </template>
          <template v-else>
            <p class="notification-content-text"><strong>Would you like to save your changes?</strong></p>
            <br/>
            <p class="notification-content-text">
              <em>Changes will only be saved if all cars on a Lot have the same wash frequency</em>
            </p>
          </template>
        </div>
        <div class="notification-footer">
          <button @click="saveWashList()" class="btn-sm btn btn-default" v-if="!listSaved">
            <i class="fa fa-save fa-fw"></i> Save
          </button>
          <button @click="listModified = false" class="btn-sm btn btn-primary">
            <i class="fa fa-times fa-fw"></i> Dismiss
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueForm from '@/components/Form'
import ResponsiveTable from '@/components/ResponsiveTable'
import Api from '@/vuex/api'
import { MODIFY_FORM_VALUE } from '@/vuex/types'

export default {
  name: 'WashList',
  components: {
    ResponsiveTable,
    VueForm
  },
  data () {
    return {
      cars: [],
      selectedOrganization: false,
      columns: [
        { title: 'Car', span: 1, name: 'convadisId', type: 'link', sort: true },
        { title: 'Lot', span: 4, name: 'address', type: 'link', sort: true, defaultSort: true },
        { title: 'Weekly', span: 2, name: 'weekly', type: 'text', sort: true },
        { title: 'Fornightly', span: 2, name: 'fornightly', type: 'text', sort: true },
        { title: 'Monthly', span: 2, name: 'monthly', type: 'text', sort: true },
        { title: 'Do Not Wash', span: 2, name: 'doNotWash', type: 'text', sort: true }
      ],
      listModified: false,
      listSaved: false
    }
  },
  computed: {
    washList () {
      return {
        title: 'Car Wash List',
        count: this.cars.length,
        columns: this.columns,
        rows: this.cars,
        group: 'suburb',
        groupIcon: 'map'
      }
    },
    toggableColumns () {
      return this.columns.filter(el => el.type === 'toggle')
    }
  },
  methods: {
    async refresh () {
      this.listModified = false
      this.listSaved = false
      let instance = new Api()
      let formData = this.$refs.form.serializeForm()
      let washTable = await instance.generateWashList(formData)
      this.cars = washTable.rows
      this.columns = washTable.columns
    },
    send () {
      this.$store.commit(MODIFY_FORM_VALUE, {
        permalink: 'generateWashList',
        name: 'cars',
        value: this.cars
      })
      this.$refs.form.submitForm()
    },
    order (col) {
      if (col.sortDirection.includes('ASC')) {
        this.cars.sort((a, b) => {
          let aValue = a[col.name].value ? a[col.name].value : a[col.name]
          let bValue = b[col.name].value ? b[col.name].value : b[col.name]
          return aValue > bValue
        })
      } else {
        this.cars.sort((a, b) => {
          let aValue = a[col.name].value ? a[col.name].value : a[col.name]
          let bValue = b[col.name].value ? b[col.name].value : b[col.name]
          return aValue < bValue
        })
      }
    },
    async saveWashList () {
      let instance = new Api()
      await instance.updateWashList(this.cars)
      this.listSaved = true
    },
    handleToggle (event) {
      this.listModified = true
      this.listSaved = false
      // whether or not the event turned the toggle on or not
      let turnedOn = event.row[event.name]
      for (let column of this.toggableColumns) {
        // if we turned a toggle on, turn the rest off
        if (turnedOn && event.name !== column.name) {
          event.row[column.name] = false
          event.row.updated = true
        } else {
          // else if we turned a toggle off, turn the doNotWash as the default
          event.row.doNotWash = true
          event.row.updated = true
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/admin/WashList.vue